import {useContext} from 'react'
import {useIntl} from 'react-intl'
import {NavContext} from '../../../../context/global_context'
import {getRequest} from '../../../../services/base'
import {downloadErrorLogs} from '../../../../utils/common'
import Button from '../../../common/Button'

const DownloadDeleteFileLogBtn = ({ isBtn = false, vehicle }) => {
  const intl = useIntl()
  const [, navDispatch] = useContext(NavContext)

  const downloadDeletedLogs = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'promoteChanges.downloadingLogs' }),
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(
      `/api/delete/promoted-files/download/?vehicle=${vehicle}`
    )
    if (res?.status) {
      if (res?.data?.file_data?.length > 0) {
        downloadErrorLogs(
          res.data.file_data,
          `${res?.data.branch_name}-${vehicle}-delete.log`
        )
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: intl.formatMessage({ id: 'promoteChanges.filesDownloaded' }),
          },
        })
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'info',
            msg: intl.formatMessage({ id: 'promoteChanges.filesIsEmpty' }),
          },
        })
      }
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: intl.formatMessage({
            id: 'promoteChanges.somethingWentWrongEx',
          }),
        },
      })
    }
  }

  return isBtn ? (
    <Button onClick={() => downloadDeletedLogs()}>
      {intl.formatMessage({ id: 'promoteChanges.downloadDeletedLogs' })}
    </Button>
  ) : (
    <Button
      type="link"
      className="link-button"
      onClick={() => downloadDeletedLogs()}
    >
      {intl.formatMessage({ id: 'promoteChanges.downloadDeletedLogs' })}
    </Button>
  )
}

export default DownloadDeleteFileLogBtn
